import type { WorkflowInputFile } from "./createWorkflowRunStore";

/**
 * Split the staged files that still lack an `sdrId` (the only ones that block a
 * kickoff) into `failed`, which the user has to remove because it will never
 * gain one, and `uploading`, which resolves on its own.
 */
export const partitionBlockingInputFiles = (files: WorkflowInputFile[]) => {
  const blocking = files.filter((file) => !file.sdrId);
  return {
    failed: blocking.filter((file) => file.uploadStatus === "failed"),
    uploading: blocking.filter((file) => file.uploadStatus !== "failed"),
  };
};
